const steps = [
  {
    n: "01",
    t: "Free LinkedIn audit",
    d: "We tear down your current profile and tell you the truth: what's working, what isn't, and whether LinkedIn is the right channel for you right now.",
  },
  {
    n: "02",
    t: "Brand build",
    d: "Banner, headline, about, featured, services and proof — rebuilt to position you as a reliable, trustworthy finance partner inside your niche.",
  },
  {
    n: "03",
    t: "Discovery & outreach",
    d: "We identify business owners actively looking for finance partners on LinkedIn and start human, personalized conversations in your voice.",
  },
  {
    n: "04",
    t: "Content that compounds",
    d: "Weekly posts written for you. Over months, your name becomes the obvious answer when an owner in your niche needs a bookkeeper.",
  },
  {
    n: "05",
    t: "Qualified calls",
    d: "Prepared business owners arrive on your calendar with context: their size, software, pain points, and why they reached out.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="py-20 lg:py-28 bg-[#F4F4F5] border-b border-[#E4E4E7]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-14 max-w-3xl">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0] mb-4">
            The system
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            A five-step build that turns LinkedIn into a long-term client engine.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-[#09090B] border border-[#09090B]">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`step-${s.n}`}
              className="bg-white p-7 lg:p-8 relative group hover:bg-[#09090B] hover:text-white transition-colors duration-300"
            >
              <p className="font-mono text-xs font-bold text-[#1F4DA0] group-hover:text-[#3FA742] tracking-widest">
                STEP {s.n}
              </p>
              <h3 className="font-display font-bold text-xl tracking-tight mt-5 leading-tight">
                {s.t}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#52525B] group-hover:text-white/70">
                {s.d}
              </p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-[#09090B] group-hover:bg-white" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
